export default function($apiInstance, $store) {
    return {
        /**
         * 작업 지시서 생성 (보철 인증서 정보 전달)
         * @param {Object} data - 작업 지시서 데이터
         * @param {Function} success - 성공 콜백
         * @param {Function} fail - 실패 콜백
         */
        createWorkOrder: async (data, success, fail) => {
            $store.commit('setStateValue', { loading: true });
            try {
                const response = await $apiInstance.post('/dental-laboratory/work-orders', data);

                if (response.status === 200 || response.status === 201) {
                    if (success) success(response);
                } else {
                    if (fail) fail(response);
                }
            } catch (error) {
                console.error('작업 지시서 생성 실패:', error);
                if (fail) fail(error);
            } finally {
                $store.commit('setStateValue', { loading: false });
            }
        },

        /**
         * 작업 지시서 목록 조회
         * @param {Object} params - 조회 파라미터
         * @param {Function} success - 성공 콜백
         * @param {Function} fail - 실패 콜백
         */
        getWorkOrders: async (params, success, fail) => {
            $store.commit('setStateValue', { loading: true });
            try {
                const response = await $apiInstance.get('/dental-laboratory/work-orders', { params });

                if (response.status === 200) {
                    if (success) success(response);
                } else {
                    if (fail) fail(response);
                }
            } catch (error) {
                console.error('작업 지시서 목록 조회 실패:', error);
                if (fail) fail(error);
            } finally {
                $store.commit('setStateValue', { loading: false });
            }
        },

        /**
         * 작업 지시서 상세 조회
         * @param {String} id - 작업 지시서 ID
         * @param {Function} success - 성공 콜백
         * @param {Function} fail - 실패 콜백
         */
        getWorkOrderDetail: async (id, success, fail) => {
            $store.commit('setStateValue', { loading: true });
            try {
                const response = await $apiInstance.get(`/dental-laboratory/work-orders/${id}`);

                if (response.status === 200) {
                    if (success) success(response);
                } else {
                    if (fail) fail(response);
                }
            } catch (error) {
                console.error('작업 지시서 상세 조회 실패:', error);
                if (fail) fail(error);
            } finally {
                $store.commit('setStateValue', { loading: false });
            }
        }
    };
}